import React from 'react'
import './style.scss'

const Index = () => {
    return (
        <div className="container-fluid py-5">
            <div className="row">
                <div className="col-12 text-center">
                    <h1>404</h1>
                    <p>Page not found !!!</p>
                </div>
            </div>
        </div>
    );
}

export default Index;